(function () {
    'use strict';

    angular
        .module('app')
        .factory('EntityDialogService', EntityDialogService);

    EntityDialogService.$inject = ['DialogService'];

    /**
     * @ngdoc service
     * @name EntityDialogService
     * 
     * @description
     * Shows a modal dialog specific to entities.
     */
    function EntityDialogService(DialogService) {
        var service = {
            confirmDeleteEntities: confirmDeleteEntities
        };

        return service;

        /**
         * Opens dialog prompting user to confirm deletion of the entities.
         *
         * @param {Array/Object} entities - The entities or references for entities which are to be deleted.
         * @param {Object} entityTemplate - Entity template for the entities.
         *
         * @return {Promise} Success if deletion is confirmed, otherwise reject.
         */
        function confirmDeleteEntities(entities, entityTemplate) {
            var count = 1;
            var templateName = '';

            if (!_.isNil(entityTemplate)) {
                templateName = entityTemplate.Name;

                if (angular.isArray(entities) && entities.length > 1) {
                    count = entities.length;

                    if (!_.isNil(entityTemplate.PluralName) && entityTemplate.PluralName !== '') {
                        templateName = entityTemplate.PluralName;
                    }
                }
            } else {
                templateName = 'item';

                if (angular.isArray(entities) && entities.length > 1) {
                    count = entities.length;

                    templateName += 's';
                }
            }

            return DialogService.confirm('Delete the ' + count + ' selected ' + templateName + '?');
        }
    }
})();